import '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import { InstrumentGetByNotationModuleFactory } from '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import '../../endpoints/notation/get.module.js';
import '../../endpoints/prices/list.module.js';
import '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import '../../endpoints/portfolio/transaction/list.module.js';
import '../../endpoints/portfolio/list.module.js';
import { PortfolioPositionListModuleFactory } from '../../endpoints/portfolio/position/list.module.js';
import '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import { NewsListStoreModuleFactory } from '../news-list/index.module.js';
import { PortfolioCreateStoreModuleFactory } from '../portfolio-create/index.module.js';
import { PortfolioPositionsListStoreModuleFactory } from '../portfolio-positions-list/index.module.js';
import { PortfolioTransactionAddStoreModuleFactory } from '../portfolio-transaction-add/index.module.js';
import { PortfolioTransactionsListStoreModuleFactory } from '../portfolio-transactions-list/index.module.js';
import { SearchSuggesterStoreModuleFactory } from '../search-suggester/index.module.js';
import { PortfolioDeleteStoreModuleFactory } from '../portfolio-delete/index.module.js';
import { PortfolioEditStoreModuleFactory } from '../portfolio-edit/index.module.js';
import { PortfolioHeaderStoreModuleFactory } from '../portfolio-header/index.module.js';
import { PortfolioListStoreModuleFactory } from '../portfolio-list/index.module.js';
import { PortfolioSelectorStoreModuleFactory } from '../portfolio-selector/index.module.js';
import { PortfolioPositionsPerformanceStoreModuleFactory } from '../portfolio-positions-performance/index.module.js';
import { PortfolioPositionsWeightStoreModuleFactory } from '../portfolio-positions-weight/index.module.js';
import { PortfolioBreakdownStoreModuleFactory } from '../portfolio-breakdown/index.module.js';
import { PortfolioEvaluationChartStoreModuleFactory } from '../portfolio-evaluation-chart/index.module.js';
import { PortfolioTransactionEditStoreModuleFactory } from '../portfolio-transaction-edit/index.module.js';
import { PortfolioTransactionDeleteStoreModuleFactory } from '../portfolio-transaction-delete/index.module.js';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';
import 'lodash.set';
import { getLanguage, getEndpointOptions, inheritEndpointOptions } from '../../helpers/common.js';

class PortfolioStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.defaultLanguage = "en";
    this.breakDownTypes = ["assetClass", "currency", "sector"];
  }
  getPortfolioPositionListRequest(id) {
    return { id };
  }
  getPortfolioEvaluationChartRequest(portfolioId, payloadLanguage) {
    return { id: portfolioId, language: getLanguage(payloadLanguage, this.defaultLanguage, this.options) };
  }
  getPortfolioPositionListData(payload) {
    var _a;
    const request = this.getPortfolioPositionListRequest(payload.id);
    const response = this.getEndpoints().portfolioPositionListModule.getData(request);
    return (_a = response == null ? void 0 : response.data) != null ? _a : null;
  }
  getNotationIds(payload) {
    var _a;
    const portfolioPositionListData = this.getPortfolioPositionListData(payload);
    const notationIds = [];
    ((_a = portfolioPositionListData == null ? void 0 : portfolioPositionListData.positions) != null ? _a : []).forEach((position) => {
      if (position.notation.id !== null) {
        notationIds.push(position.notation.id);
      }
    });
    return notationIds;
  }
  getInstrumentGetByNotationRequest(id, payloadLanguage) {
    return { id, _language: getLanguage(payloadLanguage, this.defaultLanguage, this.options) };
  }
  async updateInstrumentGetByNotation(payload, idNotation) {
    const request = this.getInstrumentGetByNotationRequest(idNotation, payload.language);
    return this.getEndpoints().instrumentGetByNotation.updateState(request);
  }
  getInstrumentId(payload, notationId) {
    const request = this.getInstrumentGetByNotationRequest(notationId, payload.language);
    const response = this.getEndpoints().instrumentGetByNotation.getData(request);
    if (!response) {
      throw new Error("Could not fetch instrument id");
    }
    return response.data.id;
  }
  getPortfolioListRequest() {
    return {};
  }
  getPortfolioListData(payload) {
    var _a;
    const request = this.getPortfolioListRequest();
    const response = this.getDependencies().portfolioList.getEndpoints().portfolioList.getData(request);
    return (_a = response == null ? void 0 : response.data) != null ? _a : null;
  }
  getNewsListCriteria(payload) {
    var _a;
    const instrumentIds = this.getInstrumentIds(payload);
    const newsListCriteria = payload.newsCriteria ? structuredClone(payload.newsCriteria) : { criteria: [] };
    (_a = newsListCriteria.criteria) == null ? void 0 : _a.push({ instruments: { ids: [...new Set(instrumentIds)] } });
    return newsListCriteria;
  }
  getInstrumentIds(payload) {
    const notationIds = this.getNotationIds(payload);
    return notationIds.map((notationId) => {
      try {
        return this.getInstrumentId(payload, notationId);
      } catch (error) {
        return null;
      }
    }).filter((instrumentId) => instrumentId);
  }
  getSelectedPortfolio(payload) {
    var _a;
    const portfolioListData = this.getPortfolioListData(payload);
    return (_a = portfolioListData == null ? void 0 : portfolioListData.find((portfolio) => portfolio.id === payload.id)) != null ? _a : null;
  }
  getResponseMeta(payload) {
    var _a, _b, _c;
    const portfolioListData = this.getPortfolioListData(payload);
    const selectedPortfolio = this.getSelectedPortfolio(payload);
    return {
      newsListCriteria: this.getNewsListCriteria(payload),
      numberOfPortfolios: (_a = portfolioListData == null ? void 0 : portfolioListData.length) != null ? _a : NaN,
      numberOfPositions: (_b = selectedPortfolio == null ? void 0 : selectedPortfolio.summary.numberPositions) != null ? _b : NaN,
      numberOfTransactions: (_c = selectedPortfolio == null ? void 0 : selectedPortfolio.summary.transactions.total.number) != null ? _c : NaN
    };
  }
  getResponse(payload) {
    return {
      data: void 0,
      meta: this.getResponseMeta(payload)
    };
  }
  getIsPortfolioTransactionAddType(actionType) {
    return actionType === `${this.getDependencies().portfolioTransactionAdd.getEndpoints().portfolioTransactionCreate.getNameSpace()}/fetchEndpointData`;
  }
  getIsPortfolioTransactionEditType(actionType) {
    return actionType === `${this.getDependencies().portfolioTransactionEdit.getEndpoints().portfolioTransactionModify.getNameSpace()}/fetchEndpointData`;
  }
  getIsPortfolioTransactionDeleteType(actionType) {
    return actionType === `${this.getDependencies().portfolioTransactionDelete.getEndpoints().portfolioTransactionDelete.getNameSpace()}/fetchEndpointData`;
  }
  getPortfolioHeaderRequest(id) {
    return { id };
  }
  async refreshPortfolioHeaderState(payload, portfolioId) {
    try {
      const request = this.getPortfolioHeaderRequest(portfolioId);
      return this.getDependencies().portfolioHeader.getEndpoints().portfolioGet.refreshState(request);
    } catch (error) {
      this.logger.error(error);
      return [];
    }
  }
  async refreshPortfolioPositionListState(payload, portfolioId) {
    try {
      const request = this.getPortfolioPositionListRequest(portfolioId);
      return this.getEndpoints().portfolioPositionListModule.refreshState(request);
    } catch (error) {
      this.logger.error(error);
      return [];
    }
  }
  async refreshPortfolioEvaluationChartState(payload, portfolioId) {
    try {
      const request = this.getPortfolioEvaluationChartRequest(portfolioId, payload.language);
      return this.getDependencies().portfolioEvaluationChart.refreshState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updatePortfolioList(payload) {
    try {
      const request = this.getPortfolioListRequest();
      return this.getDependencies().portfolioList.getEndpoints().portfolioList.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  getPortfolioTransactionListRequest(id) {
    return { id };
  }
  async refreshPortfolioTransactionsListState(payload, portfolioId) {
    try {
      const request = this.getPortfolioTransactionListRequest(portfolioId);
      return this.getDependencies().portfolioTransactionsList.getEndpoints().portfolioTransactionList.refreshState(request);
    } catch (error) {
      this.logger.error(error);
      return [];
    }
  }
  getPortfolioPositionsWeightRequest(id, payloadLanguage) {
    return { id, language: getLanguage(payloadLanguage, this.defaultLanguage, this.options) };
  }
  async refreshPortfolioPositionsWeightState(payload, portfolioId) {
    try {
      const request = this.getPortfolioPositionsWeightRequest(portfolioId, payload.language);
      return this.getDependencies().portfolioPositionsWeight.refreshState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  getPortfolioPositionsPerformanceRequest(id, payloadLanguage) {
    return { id, language: getLanguage(payloadLanguage, this.defaultLanguage, this.options) };
  }
  async refreshPortfolioPositionsPerformanceState(payload, portfolioId) {
    try {
      const request = this.getPortfolioPositionsPerformanceRequest(portfolioId, payload.language);
      return this.getDependencies().portfolioPositionsPerformance.refreshState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  getPortfolioBreakdownRequest(portfolioId, breakdownType, payloadLanguage) {
    return { id: portfolioId, breakdownType, language: getLanguage(payloadLanguage, this.defaultLanguage, this.options) };
  }
  async updatePortfolioBreakdown(payload, portfolioId, breakdownType) {
    try {
      const request = this.getPortfolioBreakdownRequest(portfolioId, breakdownType, payload.language);
      return this.getDependencies().portfolioBreakdown.updateComponentsInputs(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updatePortfolioPositionList(payload, portfolioId) {
    try {
      const request = this.getPortfolioPositionListRequest(portfolioId);
      return this.getEndpoints().portfolioPositionListModule.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  updatePortfolioPositionsState(payload, portfolioId) {
    return [
      this.refreshPortfolioHeaderState(payload, portfolioId),
      this.refreshPortfolioPositionListState(payload, portfolioId),
      this.updatePortfolioList(payload),
      this.refreshPortfolioTransactionsListState(payload, portfolioId),
      this.refreshPortfolioPositionsWeightState(payload, portfolioId),
      this.refreshPortfolioPositionsPerformanceState(payload, portfolioId),
      this.refreshPortfolioEvaluationChartState(payload, portfolioId)
    ];
  }
  async updateComponentsInputs(payload) {
    let isResponseSuccessful = true;
    this.store.subscribeAction({
      after: async (action, state) => {
        const isPortfolioTransactionAddType = this.getIsPortfolioTransactionAddType(action.type);
        const isPortfolioTransactionEditType = this.getIsPortfolioTransactionEditType(action.type);
        const isPortfolioTransactionDeleteType = this.getIsPortfolioTransactionDeleteType(action.type);
        if (isPortfolioTransactionAddType || isPortfolioTransactionEditType || isPortfolioTransactionDeleteType) {
          const portfolioId = action.payload.data.id;
          if (portfolioId) {
            await Promise.all([
              ...this.updatePortfolioPositionsState(payload, portfolioId),
              ...this.breakDownTypes.map(async (breakdownType) => this.updatePortfolioBreakdown(payload, portfolioId, breakdownType))
            ]);
          }
        }
      }
    });
    try {
      await this.updatePortfolioList(payload);
      if (payload.id) {
        await this.updatePortfolioPositionList(payload, payload.id);
        const notationIds = this.getNotationIds(payload);
        await Promise.all(notationIds.map(async (idNotation) => this.updateInstrumentGetByNotation(payload, idNotation)));
      }
    } catch (error) {
      isResponseSuccessful = false;
      this.logger.error(error);
    }
    return isResponseSuccessful;
  }
  async cleanUp(payload) {
    return Promise.resolve(true);
  }
  getEndpoints() {
    var _a;
    if (!this.endpoints) {
      const endpointConfiguration = (_a = this.options) == null ? void 0 : _a.endpointConfiguration;
      this.endpoints = {
        portfolioPositionListModule: this.getModuleEntity(PortfolioPositionListModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioPositionListModule")),
        instrumentGetByNotation: this.getModuleEntity(InstrumentGetByNotationModuleFactory, getEndpointOptions(endpointConfiguration, "instrumentGetByNotation"))
      };
    }
    return this.endpoints;
  }
  getDependencies() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
    if (!this.dependencies) {
      const endpointConfiguration = (_a = this.options) == null ? void 0 : _a.endpointConfiguration;
      const factoryData = {
        mdg2Client: this.mdg2Client,
        logger: this.logger,
        store: this.store
      };
      this.dependencies = {
        searchSuggester: new SearchSuggesterStoreModuleFactory({ ...factoryData, options: inheritEndpointOptions(endpointConfiguration, (_b = this.options) == null ? void 0 : _b.searchSuggester) }),
        newsList: new NewsListStoreModuleFactory({ ...factoryData, options: inheritEndpointOptions(endpointConfiguration, (_c = this.options) == null ? void 0 : _c.newsList) }),
        portfolioCreate: new PortfolioCreateStoreModuleFactory({ ...factoryData, options: inheritEndpointOptions(endpointConfiguration, (_d = this.options) == null ? void 0 : _d.portfolioCreate) }),
        portfolioDelete: new PortfolioDeleteStoreModuleFactory({ ...factoryData, options: inheritEndpointOptions(endpointConfiguration, (_e = this.options) == null ? void 0 : _e.portfolioDelete) }),
        portfolioEdit: new PortfolioEditStoreModuleFactory({ ...factoryData, options: inheritEndpointOptions(endpointConfiguration, (_f = this.options) == null ? void 0 : _f.portfolioEdit) }),
        portfolioHeader: new PortfolioHeaderStoreModuleFactory({ ...factoryData, options: inheritEndpointOptions(endpointConfiguration, (_g = this.options) == null ? void 0 : _g.portfolioHeader) }),
        portfolioPositionsList: new PortfolioPositionsListStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_h = this.options) == null ? void 0 : _h.portfolioPositionsList)
        }),
        portfolioList: new PortfolioListStoreModuleFactory({ ...factoryData, options: inheritEndpointOptions(endpointConfiguration, (_i = this.options) == null ? void 0 : _i.portfolioList) }),
        portfolioPositionsPerformance: new PortfolioPositionsPerformanceStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_j = this.options) == null ? void 0 : _j.portfolioPositionsPerformance)
        }),
        portfolioPositionsWeight: new PortfolioPositionsWeightStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_k = this.options) == null ? void 0 : _k.portfolioPositionsWeight)
        }),
        portfolioBreakdown: new PortfolioBreakdownStoreModuleFactory({ ...factoryData, options: inheritEndpointOptions(endpointConfiguration, (_l = this.options) == null ? void 0 : _l.portfolioBreakdown) }),
        portfolioEvaluationChart: new PortfolioEvaluationChartStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_m = this.options) == null ? void 0 : _m.portfolioEvaluationChart)
        }),
        portfolioTransactionsList: new PortfolioTransactionsListStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_n = this.options) == null ? void 0 : _n.portfolioTransactionsList)
        }),
        portfolioTransactionAdd: new PortfolioTransactionAddStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_o = this.options) == null ? void 0 : _o.portfolioTransactionAdd)
        }),
        portfolioTransactionEdit: new PortfolioTransactionEditStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_p = this.options) == null ? void 0 : _p.portfolioTransactionEdit)
        }),
        portfolioTransactionDelete: new PortfolioTransactionDeleteStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_q = this.options) == null ? void 0 : _q.portfolioTransactionDelete)
        }),
        portfolioSelector: new PortfolioSelectorStoreModuleFactory({ ...factoryData, options: inheritEndpointOptions(endpointConfiguration, (_r = this.options) == null ? void 0 : _r.portfolioSelector) })
      };
    }
    return this.dependencies;
  }
}

export { PortfolioStoreModuleFactory };
